import React, { useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import { _request } from "../../http";
import { IconButton } from "@mui/material";
import Check from "@mui/icons-material/Check";
import { useRouteLeavingGuard } from "../Forms/RouteLeavingGuard";
import { debounce } from "lodash";

function FormElement(props) {
  const [initialValue, setInitialValue] = useState(props.row[props.name]);
  const [value, setValue] = useState(props.row[props.name]);
  const endPoint = props.endPoint;
  const primaryKey = props.primaryKey;
  const blur = useRef(null);

  useRouteLeavingGuard({
    when: value !== initialValue && props.askForConfirmation,
  });

  const update = useMemo(
    () =>
      debounce(({ value }, callback) => {
        if (initialValue != value) {
          const body = new FormData();
          body.set(props.name, value);
          _request("patch", endPoint + "/" + props.row[primaryKey], body, {
            showSpinner: props.showLoadingSpinner,
          }).then((response) => {
            callback(response.data.data);
          });
        }
      }, 500),
    [initialValue, props.row, primaryKey, props.name, endPoint, props.showLoadingSpinner]
  );
  const save = () => {
    if (blur.current) {
      clearTimeout(blur.current);
      blur.current = null;
    }
    update({ value }, (newRow) => {
      // document.activeElement.blur();
      setInitialValue(newRow[props.name]);
      // props.updateRow(newRow);
    });
  };

  useEffect(() => {
    if (!props.askForConfirmation) {
      save();
    }
  }, [value]);

  useEffect(() => {
    setValue(props.row[props.name]);
  }, [props.row[props.name]]);

  return (
    <div>
      {React.cloneElement(
        props.children,
        {
          ...props,
          onChange: (e) => {
            if (props.parseBoolToInt) {
              setValue(e.target[props.valueKey] ? 1 : 0);
            } else {
              if (e.target) {
                setValue(e.target[props.valueKey]);
              } else if (props.parseOnChange) {
                setValue(props.parseOnChange(e));
              }
            }
          },
          // onBlur: (e) => {
          //   if (blur.current) {
          //     clearTimeout(blur.current);
          //   }
          //   blur.current = setTimeout(() => {
          //     setValue(initialValue);
          //   }, 500);
          // },
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              document.activeElement.blur();
              save();
            } else if (e.key === "Escape") {
              e.preventDefault();
              document.activeElement.blur();
              setValue(initialValue);
            }
          },
          focused: value != initialValue,
          [props.valueKey]: value,
        },
        [...(props.children?.props?.children ?? [])]
      )}
      {initialValue != value && props.askForConfirmation ? (
        <IconButton color={"primary"} onClick={save}>
          <Check />
        </IconButton>
      ) : null}
    </div>
  );
}

FormElement.propTypes = {
  name: PropTypes.string.isRequired,
  endPoint: PropTypes.string.isRequired,
  primaryKey: PropTypes.string,
  valueKey: PropTypes.string,
  askForConfirmation: PropTypes.bool,
  parseBoolToInt: PropTypes.bool,
  parseOnChange: PropTypes.func,
  showLoadingSpinner: PropTypes.bool,
  row: PropTypes.object.isRequired,
};

FormElement.defaultProps = {
  primaryKey: "id",
  valueKey: "value", // could be "checked" in case of switch component
  askForConfirmation: true,
  parseBoolToInt: false,
  showLoadingSpinner: true,
};

export default FormElement;
